import { render, staticRenderFns } from "./GoodsRegisterStatus.vue?vue&type=template&id=89b78ba6"
import script from "./GoodsRegisterStatus.vue?vue&type=script&lang=js"
export * from "./GoodsRegisterStatus.vue?vue&type=script&lang=js"
import style0 from "./GoodsRegisterStatus.vue?vue&type=style&index=0&id=89b78ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports